/**
 * Dynamic FAQ JSON-LD Schema Generator for OkiForm Theme
 * Scans page for <accordion-custom> elements, extracts Q&A pairs,
 * and dynamically injects the FAQPage JSON-LD schema into the <head>.
 * Runs during browser idle time to ensure maximum PageSpeed performance.
 */
(function() {
  function generateFAQSchema() {
    // Find all custom accordion details
    const accordions = document.querySelectorAll('accordion-custom details');
    if (!accordions.length) return;

    const mainEntity = [];

    accordions.forEach(details => {
      const summary = details.querySelector('summary.details__header');
      const content = details.querySelector('.details-content');
      if (!summary || !content) return;

      // Clone summary to extract question text without SVG icons or helper tags
      const summaryClone = summary.cloneNode(true);
      const elementsToRemove = summaryClone.querySelectorAll('.svg-wrapper, .details__icon, svg, img');
      for (let i = 0; i < elementsToRemove.length; i++) {
        elementsToRemove[i].remove();
      }
      const question = summaryClone.textContent.replace(/[\s\n\r]+/g, ' ').trim();

      // Get answer text content and clean whitespaces safely
      const rawAnswer = content.innerText || content.textContent || '';
      const answer = rawAnswer.replace(/[\s\n\r]+/g, ' ').trim();

      if (question && answer) {
        mainEntity.push({
          "@type": "Question",
          "name": question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": answer
          }
        });
      }
    });

    // Only inject if FAQ items are present
    if (mainEntity.length > 0) {
      // Remove any existing dynamic faq schema to prevent duplicates on view transition / dynamic page reloads
      const existingSchema = document.getElementById('faq-schema-jsonld');
      if (existingSchema) {
        existingSchema.remove();
      }

      const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": mainEntity
      };

      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'faq-schema-jsonld';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }
  }

  // Defer execution using window.requestIdleCallback if available, fallback to window.setTimeout
  const idleCallback = window.requestIdleCallback || window.setTimeout;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      idleCallback(generateFAQSchema);
    });
  } else {
    idleCallback(generateFAQSchema);
  }

  // Support for modern Shopify theme View Transitions / dynamic section loads
  document.addEventListener('shopify:section:load', generateFAQSchema);
  document.addEventListener('page:loaded', generateFAQSchema);
})();
